import {isFilterStepConfigVariableRegularShape} from 'data-frames/filters/DataFrameFilterTypes';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';
import * as Helpers from './StepConfigValidationHelpers';

const validateConfig: ConfigValidationFunction<PipelineStepType.FILTER_DATASET, 0> = (
  config,
  {'Input dataset': [dataFrameSpec]}
) => {
  // Parameter Optimization dashboards expect a single `EQUALS` condition
  if (config.filter.operation === 'EQUALS') {
    return [];
  }

  // The Analysis UI only supports a regularized filter shape
  if (!isFilterStepConfigVariableRegularShape(config.filter)) {
    return ['This filter is no longer valid.'];
  }

  return Helpers.coalesceMessages(
    config.filter.filters.some((filter) => filter.filters.length === 0)
      ? 'Each column filter must have at least one condition.'
      : null,
    Helpers.getDuplicateColumnsMessage(
      dataFrameSpec,
      config.filter.filters.map((filter) =>
        filter.filters.length === 0 ? '' : filter.filters[0].columnSystemName
      ),
      'Cannot filter the same column more than once.'
    )
  );
};

export default {
  stepType: PipelineStepType.FILTER_DATASET,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.FILTER_DATASET, 0>;
